import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { getCostCenterDetailsById } from 'RestAPIs/admin';

import showSnackbar from 'components/shared/Snackbar';

const useGetCostCenterDetailsById = (
  id: number,
  converter: (response) => any = (response) => response.data
) => {
  const { t } = useTranslation('common');

  return useQuery({
    queryKey: ['costCenterDetailsById', id],
    queryFn: async () => await getCostCenterDetailsById(id).then(converter),
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('errorDuringFetching')
      });
    }
  });
};

export default useGetCostCenterDetailsById;
